// extracted by mini-css-extract-plugin
export default {"smallBox":"MiddleSlider_smallBox__6yj+L"};